import { render, staticRenderFns } from "./PatientDocuments.vue?vue&type=template&id=643f1145&"
import script from "./PatientDocuments.vue?vue&type=script&lang=js&"
export * from "./PatientDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports